import React from "react";
import { Card } from "@/components/ui/card";
import { Mail, Lock } from "lucide-react";

export default function Email() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-heading font-bold text-navy-900">Email</h1>
        <p className="text-sm text-slate-500 mt-1">Integrazione Outlook & PEC</p>
      </div>
      <Card className="p-12 text-center">
        <Lock className="w-12 h-12 text-slate-300 mx-auto mb-4" />
        <h2 className="text-lg font-heading font-bold text-navy-900">Integrazione richiesta</h2>
        <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">
          Per attivare il client email integrato (Outlook + PEC) configura le credenziali Microsoft Graph e PEC IMAP/SMTP dalla sezione Impostazioni → Integrazioni.
        </p>
        <div className="mt-6 inline-flex items-center gap-2 text-xs text-slate-400">
          <Mail className="w-4 h-4" /> Modulo pronto, attendi configurazione admin
        </div>
      </Card>
    </div>
  );
}
